import { FormikProvider, useFormik } from "formik";
import { TextInput } from "../../components/Forms/TextField";
import { Button } from "../../components/Buttons/Button";
import { useState } from "react";
import { ITransactionBreakDown, TransactionCard } from "../transactions";
import { currencyFormat } from "../../utils/helpers";
import { PaymentModal } from "../../containers/PaymentModal";
import * as yup from "yup";
import { Loader } from "../../components/Loader";
import { validatePIN } from "../../utils/api.service";
import { toast } from "react-hot-toast";
import {
  ArrowSmallLeftIcon,
  ArrowLeftOnRectangleIcon,
} from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";

export const Validate = () => {
  const [currentState, setCurrentState] = useState<
    "validate" | "breakdown" | "receipt"
  >("breakdown");
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [, setBreakDownData] = useState<any>();

  const userData = localStorage.getItem("user_data");

  const [receipt, setReceipt] = useState([]);

  // console.log(receipt);

  const parsedUserData = userData && JSON.parse(userData);

  const navigate = useNavigate();

  const form = useFormik({
    validationSchema: yup.object({
      guid: yup.string().required().label("Validation token"),
    }),
    initialValues: { guid: "" },
    onSubmit: async (values) => {
      try {
        const response = await validatePIN(values);
        if (response.data.responseCode === "00") {
          setBreakDownData(response.data.data);
          setCurrentState("breakdown");
        } else {
          toast.error(response.data.responseMessage || "An error occured");
        }
      } catch (error) {
        toast.error("An error occured");
      }
    },
  });

  return (
    <div className=" bg-pc-light-grey h-[100vh] overflow-y-scroll">
      <PaymentModal
        parentGuid={parsedUserData?.details.parentGUid}
        onClose={(r) => {
          setOpenPaymentModal(false);
          setReceipt(r);
          setCurrentState("receipt");
        }}
        show={openPaymentModal}
      />
      <div className="shadow py-4 bg-white px-4">
        <img src="/images/logo-black.svg" alt="" className="w-1/4" />
      </div>

      <div className="container">
        {currentState === "receipt" ? (
          <div
            className={` my-3 w-fit flex `}
            onClick={() => setCurrentState("breakdown")}
          >
            <ArrowSmallLeftIcon className="w-[16px] mr-2" /> Back
          </div>
        ) : (
          <div
            className={` my-3 w-fit flex  gap-1`}
            onClick={() =>
              navigate(`/login?ref=${parsedUserData?.details.parentGUid}`)
            }
          >
            <ArrowLeftOnRectangleIcon className="h-[26px] text-red-600 " /> Log
            out
          </div>
        )}

        {currentState === "validate" && (
          <>
            <div className="text-center py-6">
              <h4 className="font-semibold">Validate</h4>
              <p> Validate your account</p>
            </div>

            <FormikProvider value={form}>
              <form onSubmit={form.handleSubmit} className="space-y-[28px]">
                <TextInput
                  label="Validation PIN"
                  {...form.getFieldProps("guid")}
                  context
                />
                {form.isSubmitting ? (
                  <div className="flex justify-center">
                    <Loader />
                  </div>
                ) : (
                  <Button btnText="Validate" fullWidth />
                )}
              </form>
            </FormikProvider>
          </>
        )}
        {currentState === "breakdown" && parsedUserData && (
          <>
            <div className="flex justify-between py-6">
              <div>
                <h4 className="font-semibold">
                  {parsedUserData?.details.payerName}
                </h4>
                <h4>
                {" "}
                  Business Name:{" "}
                  {parsedUserData?.auth.businessName}{" "}
                </h4>
                <p>
                  {" "}
                  Wallet Balance:{" "}
                  {currencyFormat(parsedUserData?.auth.walletBalance)}{" "}
                </p>
                <p>
                  {" "}
                  Total Due:{" "}
                  {currencyFormat(parsedUserData?.details.totalAmountDue)}{" "}
                </p>
                
              </div>
              <button
                className="bg-pc-blue text-white px-2 py-1 h-fit rounded"
                onClick={() => setOpenPaymentModal(true)}
              >
                Pay now
              </button>
            </div>

            {parsedUserData?.details.breakDown?.length > 0 ? (
              parsedUserData?.details.breakDown?.map(
                (breakdown: ITransactionBreakDown) => (
                  <TransactionCard
                    amountDue={breakdown.amountDue}
                    agencyCode={breakdown.agencyCode}
                    revenueCode={breakdown.revenueCode}
                    oraAgencyRev={breakdown.oraAgencyRev}
                  />
                )
              )
            ) : (
              <div className="text-center py-6">No breakdown available</div>
            )}
          </>
        )}

        {currentState === "receipt" && (
          <>
            <div className="flex justify-between py-6">
              <div>
                <h4 className="font-semibold">
                  {parsedUserData?.details.payerName}
                </h4>
                <p>
                  {" "}
                  Total Due:{" "}
                  {currencyFormat(parsedUserData?.details.totalAmountDue)}{" "}
                </p>
              </div>
            </div>

            {receipt?.length > 0 ? (
              receipt?.map((breakdown: any) => (
                <TransactionCard
                  amountDue={breakdown.amountDue}
                  agencyCode={breakdown.agencyCode}
                  revenueCode={breakdown.revenueCode}
                  paymentRef={breakdown.paymentRef}
                  receipt={breakdown.receiptLink}
                  transCode={breakdown.transCode}
                  amountPaid={parseInt(breakdown.amountPaid)}
                  webGuid={breakdown.webGuid}
                  status={breakdown.status}
                />
              ))
            ) : (
              <div className="text-center py-6">No breakdown available</div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
